// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallActionsPanel__container-eab76b {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  box-sizing: border-box;
}

.CallActionsPanel__button-container-e6c143 {
  margin-inline-end: 16px;
  position: relative;
}

.CallActionsPanel__minimised-button-container-da7f55 {
  margin-inline-end: 8px;
  position: relative;
}

.CallActionsPanel__warning-icon-f4bf62 {
  position: absolute;
  top: -6px;
  right: -6px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/CallActionsPanel/CallActionsPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.button-container {\n  margin-inline-end: 16px;\n  position: relative;\n}\n\n.minimised-button-container {\n  margin-inline-end: 8px;\n  position: relative;\n}\n\n.warning-icon {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CallActionsPanel__container-eab76b`,
	"button-container": `CallActionsPanel__button-container-e6c143`,
	"buttonContainer": `CallActionsPanel__button-container-e6c143`,
	"minimised-button-container": `CallActionsPanel__minimised-button-container-da7f55`,
	"minimisedButtonContainer": `CallActionsPanel__minimised-button-container-da7f55`,
	"warning-icon": `CallActionsPanel__warning-icon-f4bf62`,
	"warningIcon": `CallActionsPanel__warning-icon-f4bf62`
};
module.exports = ___CSS_LOADER_EXPORT___;
